import { useQuery } from "@tanstack/react-query";
import { getAllJobsEvents } from "../../../../utils";

interface Props {
  startDate?: string;
  endDate?: string;
  enabled: boolean;
}

export const useAllJobEventsQuery = ({ startDate, endDate, enabled = true }: Props) => {
  const token = sessionStorage.getItem("token");

  return useQuery({
    queryKey: ["widget-job-events", startDate, endDate],
    queryFn: () => getAllJobsEvents({
      token,
      startDate,
      endDate,
      skipEndDate: false
    }),
    // staleTime: 1000 * 60 * 60 * 2,
    enabled: enabled && Boolean(token && startDate && endDate),
    retry: 0,
  });
};
